import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textWaiter',
  standalone: false,
})
export class TextWaiterPipe implements PipeTransform {
  transform(text: string): any {
    return text ? text : `<img src="assets/three-dots.svg" />`;
  }
}
